import {useI18n as useVueI18n, type UseI18nOptions} from 'vue-i18n';
import type {WritableComputedRef} from 'vue';
import type {Locale} from './locale';

export function useI18n(options?: UseI18nOptions) {
    const composer = useVueI18n(options);
    // Рантайм не трогаем — только сужаем тип locale: string -> Locale.
    return composer as Omit<typeof composer, 'locale'> & {
        locale: WritableComputedRef<Locale>;
    };
}
